import { GROUPING_TYPE } from './grouping-type';
import { FilterDTO } from './template';
import { z } from 'zod/v4';
// ======================== Enums ========================
export enum DATASOURCE_DATA_TYPE {
  hiValue = 'hiValue',
  metrics = 'metrics',
  attributeValue = 'attributeValue',
  staticValue = 'staticValue',
  opensearch = 'opensearch',
}

export const DATASOURCE_DATA_TYPE_ENUM = z.enum(DATASOURCE_DATA_TYPE);

export const DashboardDataLinkDTO = z.object({
  id: z.string(),
  title: z.string(),
  dashboard: z.string(),
  includeCurrentVariables: z.boolean().optional(),
  variables: z.array(
    z.object({
      name: z.string(),
      source: z
        .enum(['cell', 'field', 'index', 'variable', 'literal'])
        .optional(),
      field: z.string(),
    }),
  ),
});
export type DashboardDataLink = z.infer<typeof DashboardDataLinkDTO>;

// ======================== WidgetTemplateDTO ========================
export const WidgetTemplateDTO = z.object({
  filter: z.array(FilterDTO).nullish(),
  dataLinks: z.array(DashboardDataLinkDTO).nullish(),
  linkedDashboard: z
    .object({
      dashboard: z.string()?.nullish(),
      hideDashboardButton: z.boolean().nullish(),
      mappings: z
        .array(
          z.object({
            dashboard: z.string(),
            sourceNodeId: z.string(),
            targetNodeId: z.string(),
          }),
        )
        ?.nullish(),
    })
    .nullish(),
  widgetName: z.string().nullish(),
  // title: z.string().optional(),
  widgetTitle: z
    .object({
      title: z.string().nullish(),
      hideTitle: z.boolean().nullish(),
    })
    .nullish(),
  settings: z.any().nullish(), // Generic type handled as any
  version: z.number().nullish(),
  dataSource: z
    .object({
      dataType: DATASOURCE_DATA_TYPE_ENUM.nullish(),
      dataTransform: z
        .partialRecord(z.enum(DATASOURCE_DATA_TYPE), z.string().nullish())
        .nullish(),
      grouping: z
        .object({
          type: z.enum(Object.values(GROUPING_TYPE) as [string, ...string[]]),
          showTQLNodes: z.boolean().nullish(),
        })
        .nullish(),
      cisGrouped: z.boolean().nullish(),
    })
    .catchall(z.any())
    .optional(),
});
export type WidgetTemplate = z.infer<typeof WidgetTemplateDTO>;

// ======================== WidgetDTO ========================
export const WidgetDTO = z.object({
  config: WidgetTemplateDTO,
  tab_id: z.string(),
  id: z.string(),
});
export type Widget = z.infer<typeof WidgetDTO>;

// ======================== Derived DTOs ========================
export const CreateWidgetDTO = WidgetDTO;
export type CreateWidget = z.infer<typeof CreateWidgetDTO>;

export const UpdateWidgetDTO = WidgetDTO.omit({ config: true })
  .extend({
    config: WidgetTemplateDTO.partial(),
  })
  .partial();
export type UpdateWidget = z.infer<typeof UpdateWidgetDTO>;

// ======================== WidgetResponse ========================
export const WidgetResponseSchema = z.object({
  title: z.string(),
  template: z.any(),
  dashboard_id: z.string(),
  id: z.string(),
  widgetName: z.string().nullish(),
});
export type WidgetResponse = z.infer<typeof WidgetResponseSchema>;